<template>
  <button-base :channel="channel" :show-button-labels="showButtonLabels" @click="handleClick" />
</template>

<script>
import ButtonBase from './button-base'
import MessengerMixin from '@/share/campaign/messenger-mixin'

export default {
  components: { ButtonBase },

  mixins: [MessengerMixin],

  props: {
    channel: {
      type: Object,
      required: true
    },

    showButtonLabels: {
      type: Boolean,
      required: true
    }
  }
}
</script>
